import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

export default async function GetSupportTicketTypeList() {
  const res = await api.get(routes.GET_SUPPORT_TICKET_TYPE_LIST);

  return res;
}
